import { buildModule } from '../utils';

import detail from './detail';
import list from './list';
import lazy from './lazy';

export default buildModule()
	.withSubmodules({
		detail,
		list,
		lazy,
	});
